
const MagicalAnimation = () => {
  const styles = `
    :root {
      --primary: #3f64ce;
      --skin: #f1c5b4;
      --background: #ffffff;
    }

    .scene {
      position: relative;
      width: 400px;
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .wizard {
      position: relative;
      width: 190px;
      height: 240px;
      z-index: 2;
    }

    .body {
      position: absolute;
      bottom: 0;
      left: 68px;
      height: 100px;
      width: 60px;
      background: var(--primary);
    }

    .body::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 20px;
      height: 100px;
      width: 60px;
      background: var(--primary);
      transform: skewX(14deg);
    }

    .right-arm {
      position: absolute;
      bottom: 74px;
      left: 110px;
      height: 44px;
      width: 90px;
      background: var(--primary);
      border-radius: 22px;
      transform-origin: 16px 22px;
      transform: rotate(70deg);
      animation: right_arm 4s ease-in-out infinite;
    }

    .right-hand {
      position: absolute;
      right: 8px;
      bottom: 8px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: var(--skin);
      transform-origin: center center;
      transform: rotate(-40deg);
      animation: right_hand 4s ease-in-out infinite;
    }

    .left-arm {
      position: absolute;
      bottom: 74px;
      left: 26px;
      height: 44px;
      width: 70px;
      background: var(--primary);
      border-bottom-left-radius: 8px;
      transform-origin: 60px 26px;
      transform: rotate(-70deg);
      animation: left_arm 4s ease-in-out infinite;
    }

    .left-hand {
      position: absolute;
      left: -18px;
      top: 0;
      width: 18px;
      height: 30px;
      border-radius: 35px;
      background: var(--skin);
    }

    .head {
      position: absolute;
      top: 0;
      left: 14px;
      width: 160px;
      height: 210px;
      transform-origin: center center;
      animation: head 4s ease-in-out infinite;
    }

    .beard {
      position: absolute;
      bottom: 0;
      left: 38px;
      height: 106px;
      width: 80px;
      border-bottom-right-radius: 55%;
      background: var(--background);
    }

    .face {
      position: absolute;
      bottom: 76px;
      left: 38px;
      height: 30px;
      width: 60px;
      background: var(--skin);
    }

    .hat {
      position: absolute;
      bottom: 106px;
      left: 0;
      width: 160px;
      height: 20px;
      border-radius: 20px;
      background: var(--primary);
    }

    .hat::before {
      content: "";
      position: absolute;
      top: -70px;
      left: 50%;
      transform: translateX(-50%);
      border-style: solid;
      border-width: 0 34px 70px 50px;
      border-color: transparent transparent var(--primary) transparent;
    }

    .objects {
      position: absolute;
      bottom: 50px;
      left: -100px;
      width: 200px;
      height: 240px;
    }

    .square, .circle, .triangle {
      position: absolute;
      animation: float 3s ease-in-out infinite;
    }

    .square {
      top: 50px;
      left: 20px;
      width: 40px;
      height: 40px;
      background: #9ab3f5;
      animation-delay: 0s;
    }

    .circle {
      top: 100px;
      right: 20px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #c56183;
      animation-delay: 0.5s;
    }

    .triangle {
      bottom: 50px;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 40px solid #89beb3;
      animation-delay: 1s;
    }

    @keyframes float {
      0%, 100% { transform: translateY(0px) rotate(0deg); }
      50% { transform: translateY(-20px) rotate(180deg); }
    }

    @keyframes right_arm {
      0%, 100% { transform: rotate(70deg); }
      50% { transform: rotate(20deg); }
    }

    @keyframes left_arm {
      0%, 100% { transform: rotate(-70deg); }
      50% { transform: rotate(-20deg); }
    }

    @keyframes right_hand {
      0%, 100% { transform: rotate(-40deg); }
      50% { transform: rotate(0deg); }
    }

    @keyframes head {
      0%, 100% { transform: rotate(-3deg); }
      50% { transform: rotate(3deg); }
    }

    .progress {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 200px;
      height: 4px;
      background: #eee;
      overflow: hidden;
    }

    .progress::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background: var(--primary);
      animation: loading 3s linear infinite;
    }

    @keyframes loading {
      0% { width: 0; }
      100% { width: 100%; }
    }

    .sparkle {
      position: absolute;
      pointer-events: none;
    }

    .sparkle::before,
    .sparkle::after {
      content: "";
      position: absolute;
      width: 4px;
      height: 4px;
      background: gold;
      border-radius: 50%;
      animation: sparkle 1.5s ease-in-out infinite;
    }

    @keyframes sparkle {
      0%, 100% { transform: scale(0); opacity: 0; }
      50% { transform: scale(1); opacity: 1; }
    }
  `;

  return (
    <div className="flex items-center justify-center min-h-screen">
      <style>{styles}</style>
      <div className="scene">
        <div className="objects">
          <div className="square"></div>
          <div className="circle"></div>
          <div className="triangle"></div>
        </div>
        <div className="wizard">
          <div className="body"></div>
          <div className="right-arm">
            <div className="right-hand"></div>
          </div>
          <div className="left-arm">
            <div className="left-hand"></div>
          </div>
          <div className="head">
            <div className="beard"></div>
            <div className="face"></div>
            <div className="hat"></div>
          </div>
        </div>
        <div className="sparkle" style={{ top: "30%", left: "20%" }}></div>
        <div className="sparkle" style={{ top: "40%", right: "25%" }}></div>
        <div className="sparkle" style={{ bottom: "35%", left: "30%" }}></div>
        {/* <div className="progress"></div> */}
      </div>
    </div>
  );
};

export default MagicalAnimation;